<template>
  <v-dialog persistent :value="value" @input="$emit('input')" max-width="500px">
    <v-card class="client-login-account-modal">
      <v-toolbar dense class="">
        <v-toolbar-title>Update Client Login Account</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <!-- Popup content -->
        <v-card class="client-login-account-modal__content">
          <v-card-text class="client-login-account-modal__accounts">
              <!-- <v-text-field
                prepend-icon="perm_identity"
                label="Client Login Email" placeholder="Create new Client Account"
                :value="userClient.email" disabled
              ></v-text-field>
              <v-text-field
                prepend-icon="security"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :type="show1 ? 'text' : 'password'" label="Enter Password"
                v-model="userClient.password"
                hint="Recommended for at least 8 characters"
                counter
                @click:append="show1 = !show1"
              ></v-text-field> -->
              <v-list class="mb-2" dense v-for="(account, index) in existingAccounts" :key="index">
                <v-list-item dense>
                  <v-text-field
                    class="ma-0 pa-0"
                    prepend-icon="perm_identity"
                    label="Client Login Email"
                    placeholder="Create new Client Account"
                    :value="account.email"
                    disabled
                  ></v-text-field>
                </v-list-item>
                <v-list-item dense>
                  <v-text-field
                    prepend-icon="security"
                    :append-icon="account.show1 ? 'visibility' : 'visibility_off'"
                    :type="account.show1 ? 'text' : 'password'" label="Enter Password"
                    v-model="account.password"
                    hint="Recommended for at least 8 characters"
                    counter
                    @click:append="updateAccShow(index)"
                  ></v-text-field>
                </v-list-item>
                <v-list-item dense class="justify-end">
                  <v-btn       
                    text                              
                    color="error"
                    @click="removeExistingAccount(index)"
                  >
                    <v-icon left>mdi-delete-forever</v-icon>  Delete                         
                  </v-btn>
                </v-list-item>
                <v-divider class="ma-0 pa-0"></v-divider>
              </v-list>
              <v-list class="mb-2" dense v-for="(account, index) in newAccounts" :key="index">
                <v-list-item dense>
                  <v-select
                    class="mb-2"
                    v-model="account.email"
                    :items="account.newEmails"
                    item-text="email"
                    outlined
                    label="Client Login Email"
                    dense
                    hide-details
                    @change="checkAccEmail(index)"
                  ></v-select>
                </v-list-item>
                <v-list-item style="margin-top:-15px" v-if="account.invalid" dense>
                  <p class="pt-2 text-danger">Email Already Exists.</p>
                </v-list-item>
                <v-list-item>
                  <v-text-field
                    prepend-icon="security"
                    :append-icon="account.show1 ? 'visibility' : 'visibility_off'"
                    :type="account.show1 ? 'text' : 'password'" label="Enter Password"
                    v-model="account.password"
                    hint="Recommended for at least 8 characters"
                    counter
                    @click:append="account.show1 = !account.show1"
                  ></v-text-field>
                </v-list-item>
                <v-list-item dense class="justify-end">
                  <v-btn       
                    text                              
                    color="error"
                    @click="removeNewAccount(index)"
                  >
                    <v-icon left>mdi-delete-forever</v-icon>  Delete                         
                  </v-btn>
                </v-list-item>
                <v-divider class="ma-0 pa-0"></v-divider>
              </v-list>
              <v-btn                         
                color="info"
                class="ma-2 white--text"    
                @click="addNewAccount()"
                :disabled="disableAddNew"                                
              >
                <v-icon left dark>mdi-plus</v-icon> Add Account
              </v-btn>
          </v-card-text>

          <!-- <v-card-text>
            <v-expansion-panels v-model="accountPanels" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>Account Details</v-expansion-panel-header>
                <v-expansion-panel-content>
                 
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text> -->
          <!-- Footer -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal"> Close </v-btn>
            <v-btn class="info" @click="updateClientUser">Save changes</v-btn>
          </v-card-actions>
          <small>*If client don't have the email address, the system will automatically create a login email.</small>
        </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import clientAPIs from './clientAPIs'
import userAPIs from '../User/userAPIs'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate';
import utils from '../../../utils';
export default {
  name: 'UpdateClientUserModal',
  props: {
    existingAccounts: Array,
    clientContacts: Array,
    clientLoginData: Object,
    value: Boolean
  },
  mixins: [validationMixin],
  data () {
    return {
      show1: false,
      userClient: {
        firstName: '',
        lastName: '',
        email: '',
        profilePicture: '',
        password: ''
      },
      newEmails: [],
      newAccounts: [],
      deleted: []
    }
  },
  watch: {
    clientLoginData: function (newClientData) {
      const clientObj = this.userClient
      this.userClient = Object.assign(clientObj, newClientData)
      this.userClient.password = ''
      this.newAccounts = []
      this.deleted = []
    },
    existingAccounts: function(newVal) {
      let existEmails = newVal.map(e => e.email)
      if (this.userClient.contacts) {
        this.newEmails = this.userClient.contacts.filter(val => !existEmails.includes(val.email))
      }
    }
  },
  validations: {
    userClient: {
      password: {
        required
      }
    }
  },
  computed: {
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.userClient.password.$dirty) return errors;
      !this.$v.userClient.password.required && errors.push('Password is required');
      return errors;
    },
    disableAddNew() {
      if (this.newAccounts.length === this.newEmails.length) {
        return true
      }
      return false
    },
    invalidContactEmail() {
      let isInvalid = false
      this.newAccounts.map(c => {
        if (c.invalid) isInvalid = true
      })
      return isInvalid
    }
  },
  methods: {
    updateClientUser: function () {
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //   this.$swal({
      //     type: 'error',
      //     title: `Can't Submit with errors`,
      //     text: 'Make sure you filled the required information correctly.'
      //   });
      //   return;
      // }
      // check for duplicated email accounts
      let hasDuplicates = arr => new Set(arr).size !== this.newAccounts.length
      let emails = this.newAccounts.map(a => a.email)
      if (hasDuplicates(emails)) {
        this.$swal({
          type: 'error',
          title: `Duplicated Email Accounts`,
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      }
      if (this.invalidContactEmail) {
        this.$swal({
          type: 'error',
          title: `Account email already exists.`
        });
        return;
      }
      // assign existing accounts
      this.existingAccounts = this.existingAccounts.filter(e => e.password)
      // assign update data
      const client = Object.assign({}, {
        userClient: this.userClient,
        userAccounts: this.newAccounts,
        existingAccounts: this.existingAccounts,
        deleteAccounts: this.deleted.map(d => d.id)
      })
      delete client.companyID
      // Edit client
      clientAPIs.updateClientUser(client)
        .then(response => {
          this.updateClientUserCampaigns()
          // Dismiss modal by triggering the click event on Close button
          this.$swal({
            title: 'Success',
            text: 'You have updated the client login details. Please take note the login details in a secure place.',
            type: 'success'
          }).then(() => {
            this.$emit('reRenderDataTable')
            this.closeModal()
          })
        })
        .catch(error => {
          // Request failed.
          this.$swal({
            title: 'Error',
            type: 'error',
            text: error
          })
          console.log('error', error)
        })
    },
    addNewAccount: function() {
      let newAccount = {
        clientID: this.clientLoginData.clientID,
        email: '',
        password: '',
        newEmails: utils.func.refreshJSON(this.newEmails),
        show1: false,
        invalid: false
      }
      this.newAccounts.push(newAccount)
    },
    removeExistingAccount: function(index) {
      this.deleted.push(this.existingAccounts[index])
      this.existingAccounts.splice(index, 1)
    },
    removeNewAccount: function(index) {
      this.newAccounts.splice(index, 1)
    },
    clearData: function() {
      this.userClient = {
        firstName: '',
        lastName: '',
        email: '',
        profilePicture: ''
      }
    },
    closeModal: function () {
      this.$v.$reset();
      this.clearData();
      this.$emit('input');
    },
    updateAccShow(index) {
      this.existingAccounts[index].show1 = !this.existingAccounts[index].show1
      this.existingAccounts = JSON.parse(JSON.stringify(this.existingAccounts))
    },
    async checkAccEmail(index) {
      this.invalidContactEmail = false
      this.newAccounts[index].invalid = false
      let contactOne = this.newAccounts[index]
      let resp = await userAPIs.checkClientUser({
        clientID: this.clientLoginData.clientID,
        email: contactOne.email
      })
      if (!resp.success) {
        // if email exists, show invalid
        this.newAccounts[index].invalid = true
        this.invalidContactEmail = true
      }
    },
    async updateClientUserCampaigns() {
      for (let contact of this.userClient.contacts) {
        let email = contact.email
        let campaigns = []
        this.userClient.contacts.map(c => {
          if (c.email === email) {
            if (c.campaigns) {
              c.campaigns.map(campaign => {
                campaigns.push(campaign)
              })
            }
          }
        })
        let updateContact = Object.assign({}, contact)
        updateContact.campaigns = campaigns
        await userAPIs.updateClientUserCampaigns(updateContact)
      }
    }
  }
}
</script>

<style scoped>
.client-login-account-modal {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
}

.client-login-account-modal__content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.client-login-account-modal__accounts {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
</style>

<style>
</style>



// WEBPACK FOOTER //
// UpdateClientUserModal.vue?4172f7ba